import React from 'react';
import { useDrag } from 'react-dnd';
import { Paper, Typography, SvgIcon } from '@mui/material';
import { InsertDriveFile, Cloud, TableChart, Memory, Assessment, PlaylistAddCheck } from '@mui/icons-material';
import {useTheme} from '@mui/material/styles'
function Widget({ name, type }) {

  const theme = useTheme()

  const [, ref] = useDrag({
    type: 'WIDGET',
    item: { name }
  });

  // Define styles, labels, and icons based on the node type
  let backgroundColor = '#E0E0E0'; // Default background color
  let label = name;
  let icon = null;

  switch (type) {
    case 'DataSourceNode':
      backgroundColor = '#2C74B3' // Yellow for Data Source Node
      label = 'Data Source';
      icon = <SvgIcon component={InsertDriveFile} fontSize="large" />;
      break;
    case 'TransformationNode':
      // backgroundColor = '#2196F3'; // Blue for Transformation Node
      backgroundColor = '#205295'
      label = 'Transform';
      icon = <SvgIcon component={Cloud} fontSize="large" />;
      break;
    case 'ModelNode':
      // backgroundColor = '#4CAF50'; // Green for Model Node
      backgroundColor = '#144272'
      label = 'Model';
      icon = <SvgIcon component={Memory} fontSize="large" />;
      break;
    case 'VisualizationNode':
      // backgroundColor = 'purple'; // Purple for Visualization Node
      backgroundColor='#0A2647'
      label = 'Visualization';
      icon = <SvgIcon component={Assessment} fontSize="large" />;
      break;
    case 'DecisionNode':
      backgroundColor = '#F44336'; // Red for Decision Node
      label = 'Decision';
      icon = <SvgIcon component={PlaylistAddCheck} fontSize="large" />;
      break;
    default:
      break;
  }

  return (
    <Paper 
      ref={ref}
      style={{ 
        width: 'calc(50% - 20px)', // Takes half the container width minus a little space for margin
        height: '80px',           // Adjusted height to accommodate the icon
        padding: '10px', 
        margin: '5px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: backgroundColor, // Apply the background color based on type
        color: 'white', // Text color
        
      }}
      elevation={3} // Adjust the elevation as needed
    >
      {icon}
      <Typography variant="body2">{label}</Typography>
    </Paper>
  );
}

export default Widget;
